/*
	Define all data and data-interactions for Transactions.

	Transactions are the literal claims and disputes being processed by ARIA.
	When processed, they will have decisions with a breakdown by factor.
	The factors that weighed in on the decision can be interrogated per-transaction.
*/

import TransactionService from '@/services/TransactionService.js';

export const state = {
	transactions: {}
};


/* Basic structure.... 
	try {
		const response = await axios.get(`/api/METHOD}`);
		let myVar = parseItem(response, 200);
		myVar.prop = `example`;
		return myVar;
	} catch (error) {
		console.error(error);
		return null;
	}
*/

/*
	Actions hook up to the interface, but they do not touch the store data directly.
	They can be rather complicated and will generally lean on one or more mutations.
	Actions are also the communication layer with external sources (API).

	Actions come with access to four contexts ({ state, getters, commit, dispatch })
		state = direct data access... avoid use
		getters = indirect data access... this is good
		commit = call a mutation
		dispatch = for us, dispatch will almost certainly be an axios api call
*/
export const actions = {

	retrieveInitialDecision({ commit }) {
		let requestObj = {
			profileId: 'profileId',
			clientId: 'clientId'
		};
		TransactionService.getInitialDecision(requestObj).then(() => {
			commit('GET_INITIAL_DECISION');
		});
	}
};

/*
	Mutations are methods that act on the state data directly.
	They should be incredibly basic and perform a single task.

	Mutations always take in the current 'state' and a payload.
*/
export const mutations = {
	GET_INITIAL_DECISION(state, param1) {
		return param1;
	}
};


/*
	Getters are non-cached access points to the state data.
	They allow us to interrogate the data and pull back dynamic subsets.

export const getters = {
	getThingById: state => id => state.thinglist.find(thing => thing.id === id),
};
*/
